/**
 * BundleSuite BYOB — show active tier % on summary discount label.
 * Scoped to .bundlesuite-container; driven by BYOBConfig + app custom events.
 */
(function () {
  const SELECTORS = {
    container: '.bundlesuite-container',
    label: '.side-cart-checkout-item.discount .discount-text',
    discountValue: '.side-cart-checkout-item.discount .discount-value',
    quantityCount: '.added-products-count',
    checkoutWrapper: '.side-cart-checkout-wrapper',
    stepperItem:
      '.side-cart-stepper .discount-stepper-item.active:not(.always-active)',
  };

  let eventsBound = false;
  let observer = null;

  function isByobPage() {
    return !!document.querySelector(SELECTORS.container);
  }

  function getBaseLabel() {
    return window.BYOBConfig?.styles?.css?.discountText || 'Discount';
  }

  function getOffText() {
    return window.BYOBConfig?.styles?.css?.tierOffText || 'Off';
  }

  function getTiers() {
    const tiers = window.BYOBConfig?.discount?.tiers;
    if (!Array.isArray(tiers)) return [];
    return [...tiers].sort(
      (a, b) => Number(b.requirement) - Number(a.requirement)
    );
  }

  function getQuantity(detail) {
    if (detail && typeof detail.totalQuantity === 'number') {
      return detail.totalQuantity;
    }

    const countEl = document.querySelector(
      `${SELECTORS.container} ${SELECTORS.quantityCount}`
    );
    if (!countEl) return 0;

    const qty = parseInt(countEl.textContent, 10);
    return Number.isNaN(qty) ? 0 : qty;
  }

  function getDiscountCents(detail) {
    if (detail && typeof detail.discount === 'number') {
      return detail.discount;
    }

    const valueEl = document.querySelector(
      `${SELECTORS.container} ${SELECTORS.discountValue}`
    );
    if (!valueEl) return 0;

    const digits = valueEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
    const amount = parseFloat(digits);
    return Number.isNaN(amount) ? 0 : Math.round(amount * 100);
  }

  function getApplicableTier(qty, tiers) {
    return tiers.find(tier => qty >= Number(tier.requirement)) || null;
  }

  function getStepperFallbackLabel(baseLabel) {
    const items = document.querySelectorAll(
      `${SELECTORS.container} ${SELECTORS.stepperItem}`
    );
    if (!items.length) return null;

    const lastActive = items[items.length - 1];
    const pctText = lastActive
      .querySelector('.discount-value p')
      ?.textContent?.trim();
    if (!pctText) return null;

    return `${baseLabel} (${pctText})`;
  }

  function updateDiscountLabel(detail) {
    if (!isByobPage()) return;

    const labelEl = document.querySelector(
      `${SELECTORS.container} ${SELECTORS.label}`
    );
    if (!labelEl) return;

    const baseLabel = getBaseLabel();
    const qty = getQuantity(detail);
    const discountCents = getDiscountCents(detail);
    const applicableTier = getApplicableTier(qty, getTiers());
    let nextLabel = baseLabel;

    if (discountCents > 0) {
      if (applicableTier) {
        nextLabel = `${baseLabel} (${applicableTier.value}% ${getOffText()})`;
      } else {
        const fallback = getStepperFallbackLabel(baseLabel);
        if (fallback) nextLabel = fallback;
      }
    }

    if (labelEl.textContent !== nextLabel) {
      labelEl.textContent = nextLabel;
    }
  }

  function bindCheckoutObserver() {
    if (observer) return;

    const wrapper = document.querySelector(
      `${SELECTORS.container} ${SELECTORS.checkoutWrapper}`
    );
    if (!wrapper || typeof MutationObserver === 'undefined') return;

    observer = new MutationObserver(() => updateDiscountLabel());
    observer.observe(wrapper, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function bindEvents() {
    if (!eventsBound) {
      eventsBound = true;

      ['bundleInitialized', 'byob:cartUpdated', 'stepperTextChanged'].forEach(
        eventName => {
          document.addEventListener(eventName, event => {
            updateDiscountLabel(event.detail);
          });
        }
      );
    }

    bindCheckoutObserver();
  }

  function init() {
    if (!isByobPage()) return;

    bindEvents();
    updateDiscountLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bundleInitialized', init);
})();
